import TransactionHistoricChargeRow from './TransactionHistoricChargeRow';

export default TransactionHistoricChargeRow;
